import React from "react";
import "../../App.css";
import MarfatiyaForm from "../MarfatiyaForm";

function Marfatiya({ sessionObject }) {
  // if(!sessionObject.sessionVariables["modules"].includes("marfatiya")){
  //   return;}
  return (
    <div className="page-challan">
      <MarfatiyaForm sessionObject={sessionObject} />
    </div>
  );
}

export default Marfatiya;
